import React from 'react';
import { Enum_Action_Button_Enum } from '@hooks/useUserActionLog';
import { MenuStateEnum, MenuTypes } from '../useDrawer';
import {
  DocumentAttachment,
  ImageCopy,
  ImageSearch,
  Result,
  ToolKit
} from '@carbon/icons-react';

type MenuListItem = {
  icon: React.ReactNode;
  name: string;
  menu: MenuTypes;
  logId: Enum_Action_Button_Enum;
};

export const menuListItems: MenuListItem[] = [
  {
    icon: <ImageSearch />,
    name: 'CAPA 뷰어',
    menu: MenuStateEnum.Viewer,
    logId: Enum_Action_Button_Enum.Button_Chat_Side_Viewer
  },
  {
    icon: <ImageCopy />,
    name: '도면관리',
    menu: MenuStateEnum.DrawingFileManagement,
    logId: Enum_Action_Button_Enum.Button_Chat_Side_DrawingFile_Management
  },
  {
    icon: <DocumentAttachment />,
    name: '요청서',
    menu: MenuStateEnum.Request,
    logId: Enum_Action_Button_Enum.Button_Chat_Side_Request
  },
  {
    icon: <Result />,
    name: '견적서',
    menu: MenuStateEnum.Quotation,
    logId: Enum_Action_Button_Enum.Button_Chat_Side_Quotation
  },
  {
    icon: <ToolKit />,
    name: '제조현황',
    menu: MenuStateEnum.PurchaseOrder,
    logId: Enum_Action_Button_Enum.Button_Chat_Side_PurchaseOrder
  }
];
